<template>
  <div class="policyContrast">
    <!-- 面包屑 -->
    <div class="breadcrumb m">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/policy_info'}">政策通列表</el-breadcrumb-item>
        <el-breadcrumb-item >政策对比</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="fixed m" :style="{height: fixedHeight+'px'}">
      <div class="fixed_c">
        <div class="tabs m">
          <ul>
            <li :class="{active:active==='db_box1'}" @click="handleClick('db_box1')">政策名称</li>
            <li :class="{active:active==='db_box2'}" @click="handleClick('db_box2')">政策来源</li>
            <li :class="{active:active==='db_box3'}" @click="handleClick('db_box3')">申报时间</li>
            <li :class="{active:active==='db_box4'}" @click="handleClick('db_box4')">产业类别</li>
            <li :class="{active:active==='db_box5'}" @click="handleClick('db_box5')">支持力度</li>
            <li :class="{active:active==='db_box6'}" @click="handleClick('db_box6')">支持对象</li>
            <li :class="{active:active==='db_box7'}" @click="handleClick('db_box7')">申报条件</li>
            <li :class="{active:active==='db_box8'}" @click="handleClick('db_box8')">申报材料</li>
            <li :class="{active:active==='db_box9'}" @click="handleClick('db_box9')">申报项目</li>
            <li :class="{active:active==='db_box10'}" @click="handleClick('db_box10')">联系人信息</li>
            <li :class="{active:active==='db_box11'}" @click="handleClick('db_box11')">申报入口</li>
          </ul>
        </div>
        <div class="db_box db_box_name mt8" id="db_box1">
          <h4 class="title">政策名称</h4>
          <ul>
            <li v-for="item,index in contrasts">
              <a href="javascript:;" class="close" @click="removeBtn(index)">
                <i class="icon-close"></i>
              </a>
              <div class="txt">
                {{item.name}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main m">
      <div class="db_box mt8" id="db_box2">
        <h4 class="title">政策来源</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt">
              {{item.source}}
            </div>
          </li>
        </ul>
      </div>
      <div class="db_box mt8" id="db_box3">
        <h4 class="title">申报时间</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt">
              {{item.start_date||item.release_date}} - {{item.end_date}}
            </div>
          </li>
        </ul>
      </div>
      <div class="db_box db_box_types mt8" id="db_box4">
        <h4 class="title">产业类别</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <dl>
              <dd v-for="it,idx in item.types" :class="['col'+(idx+1)]">{{it}}</dd>
            </dl>
          </li>
        </ul>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box5}" id="db_box5">
        <h4 class="title">支持力度</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_support"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box5">
          <div :class="{more:true, 'up':!boxMore.db_box5}" @click="boxMore.db_box5=!boxMore.db_box5">
            {{boxMore.db_box5?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box6}" id="db_box6">
        <h4 class="title">支持对象</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_object"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box6">
          <div :class="{more:true, 'up':!boxMore.db_box6}" @click="boxMore.db_box6=!boxMore.db_box6">
            {{boxMore.db_box6?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box7}" id="db_box7">
        <h4 class="title">申报条件</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_condition"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box7">
          <div :class="{more:true, 'up':!boxMore.db_box7}" @click="boxMore.db_box7=!boxMore.db_box7">
            {{boxMore.db_box7?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box8}" id="db_box8">
        <h4 class="title">申报材料</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_materials"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box8">
          <div :class="{more:true, 'up':!boxMore.db_box8}" @click="boxMore.db_box8=!boxMore.db_box8">
            {{boxMore.db_box8?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box9}" id="db_box9">
        <h4 class="title">申报项目</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_project"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box9">
          <div :class="{more:true, 'up':!boxMore.db_box9}" @click="boxMore.db_box9=!boxMore.db_box9">
            {{boxMore.db_box9?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div :class="{'db_box mt8': true, 'db_box_h320': boxMore.db_box10}" id="db_box10">
        <h4 class="title">联系人信息</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt ck-text" v-html="item.declare_contacts"></div>
          </li>
        </ul>
        <template v-if="boxMoreBtn.db_box10">
          <div :class="{more:true, 'up':!boxMore.db_box10}" @click="boxMore.db_box10=!boxMore.db_box10">
            {{boxMore.db_box10?'查看更多':'收起'}}
            <i class="icon-xia"></i>
          </div>
        </template>
      </div>
      <div class="db_box mt8" id="db_box11">
        <h4 class="title">申报入口</h4>
        <ul>
          <li v-for="item,index in contrasts">
            <div class="txt">
              <a class="link" v-if="item.declare||item.old_id" :href="item.declare||item.old_id" target="_blank">{{item.declare||item.old_id}}</a>
            </div>
          </li>
        </ul>
      </div>
      <!-- 导出按钮 -->
      <div class="excelBtn" @click="exportExcel">
        <i class="icon-excel"></i>
        <span>导出结果到Excel</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        active: 'db_box1',
        contrasts:[],
        scrollHeight:{},
        boxMore:{},
        boxMoreBtn:{},
        fixedHeight: 0
      }
    },
    created() {
      this.getPolicyByIds();
    },
    mounted(){
      this.$nextTick(()=>{
        //监听滚动
        window.addEventListener('scroll',this.scrollTab);
      })
    },
    beforeDestroy(){
      window.removeEventListener('scroll',this.scrollTab);
    },
    methods:{
      getPolicyByIds(){
        //获取对比政策
        let contrast = localStorage.getItem('policy_contrast');
        contrast = contrast!==null?JSON.parse(contrast):[];
        let ids = contrast.map(it=>it.id);
        this.api.getPolicyByIds({
          ids: ids.join(',')
        }, true).then(res=>{
          if(res.error['err_code'] !==0)return;
          let list = res.obj.list;
          list.forEach(item=>{
            //类别
            let types_name = item.types_name ? item.types_name.trim().split(' ') : [];
            item.types = types_name||[];
          })
          this.contrasts = list;
          this.$nextTick(()=>{
            //内容高度
            this.getScrollHeight();
          })
        })
      },
      //导出excel
      exportExcel(){
        let ids = this.contrasts.map(it=>it.id);
        this.api.exportDBExcel({
          responseType: 'blob',
          ids: ids.join(',')
        },true).then(res=>{
          if(res.error && res.error.err_code !== 0) return;
          this.downBlob(res,'政策对比导出.xls')
        })
      },
      //下载blob
      downBlob(res, fileName){
        const blob = new Blob([res]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      },
      //获取所有db_box的高度
      getScrollHeight(){
        let obj = {
          db_box1: document.querySelector('#db_box1').scrollHeight,
          db_box2: document.querySelector('#db_box2').scrollHeight,
          db_box3: document.querySelector('#db_box3').scrollHeight,
          db_box4: document.querySelector('#db_box4').scrollHeight,
          db_box5: document.querySelector('#db_box5').scrollHeight,
          db_box6: document.querySelector('#db_box6').scrollHeight,
          db_box7: document.querySelector('#db_box7').scrollHeight,
          db_box8: document.querySelector('#db_box8').scrollHeight,
          db_box9: document.querySelector('#db_box9').scrollHeight,
          db_box10: document.querySelector('#db_box10').scrollHeight,
          db_box11: document.querySelector('#db_box11').scrollHeight
        }
        let obj2={};
        Object.keys(obj).forEach(key=>{
          if(obj[key]>=320){
            obj2[key] = true;
          }else{
            obj2[key] = false;
          }
        })
        this.scrollHeight = obj;
        this.boxMore = obj2;
        this.boxMoreBtn = Object.assign({},obj2);
        this.fixedHeight = obj.db_box1 + 62;
      },
      //滚动监听tab
      scrollTab(e){
        let tabs = document.querySelector('.fixed');
        //如果页面滚动到tab位置则固定tab
        if(document.documentElement.scrollTop >= tabs.offsetTop){
          document.querySelector('.fixed_c').style.position = 'fixed';
          document.querySelector('.fixed_c').style.top = '0px';
          document.querySelector('.fixed_c').style['box-shadow'] = '0px 0px 10px 0px rgba(0,0,0,0.1)'
        }else{
          document.querySelector('.fixed_c').style.position = 'relative';
          document.querySelector('.fixed_c').style.top = '0';
          document.querySelector('.fixed_c').style['box-shadow'] = '0 0 0 0'
        }
        //页面上所有板块距离顶部的位置
        let obj = {
          db_box1: document.querySelector('#db_box1').offsetTop,
          db_box2: document.querySelector('#db_box2').offsetTop,
          db_box3: document.querySelector('#db_box3').offsetTop,
          db_box4: document.querySelector('#db_box4').offsetTop,
          db_box5: document.querySelector('#db_box5').offsetTop,
          db_box6: document.querySelector('#db_box6').offsetTop,
          db_box7: document.querySelector('#db_box7').offsetTop,
          db_box8: document.querySelector('#db_box8').offsetTop,
          db_box9: document.querySelector('#db_box9').offsetTop,
          db_box10: document.querySelector('#db_box10').offsetTop,
          db_box11: document.querySelector('#db_box11').offsetTop
        }
        let objKeys = Object.keys(obj);
        let objValues = Object.values(obj);
        objValues.forEach((item,index)=>{
          //滚动条位置大于等于某个板块的位置
          if(document.documentElement.scrollTop >= (item-this.fixedHeight)){
            //切换设置tabs的选中状态
            this.active = objKeys[index]
          }
        })
      },
      //点击切换tabs
      handleClick(val){
        this.active = val;
        let dom = document.querySelector('#'+val);
        let el = document.documentElement;
        this.scrollTo(dom.offsetTop-this.fixedHeight, 200, el)
      },
      //页面滚动到指定位置
      scrollTo(number = 0, time, el){
        if (!time) {
          document.documentElement.scrollTop = number;
          return number;
        }
        const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
        let spacingInex = time / spacingTime; // 计算循环的次数
        let nowTop = document.documentElement.scrollTop; // 获取当前滚动条位置
        let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
        let scrollTimer = setInterval(() => {
          if (spacingInex > 0) {
            spacingInex--;
            this.scrollTo(nowTop += everTop);
          } else {
            clearInterval(scrollTimer); // 清除计时器
          }
        }, spacingTime);
      },
      //删除一条
      removeBtn(index){
        this.contrasts.splice(index,1);
        localStorage.setItem('policy_contrast',JSON.stringify(this.contrasts));
        //获取项目名称行的高度
        this.$nextTick(()=>{
          let box1 = document.querySelector('#db_box1').scrollHeight;
          this.fixedHeight = box1 + 62;
        })
        //如果对比的政策为空则返回列表
        if(this.contrasts.length===0){
          this.$router.go(-1);
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "./style";
.policyContrast{
  background-color: #F3F6F8;
  .mt16{
    margin-top: 16px;
  }
  .mt8{
    margin-top: 8px;
  }
  //包屑
  .breadcrumb {
    width: 1200px;
    margin: 0 auto;
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-breadcrumb__item span{
      color: #666666;
    }
    .el-breadcrumb>.el-breadcrumb__item:last-child>.el-breadcrumb__inner{
      font-weight: 400;
      color: #4c84ff;
    }
    .el-breadcrumb>.el-breadcrumb__item>.is-link{
      font-weight: 400;
    }
    .el-breadcrumb>.el-breadcrumb__item:last-child{
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .main{
    padding-bottom: 40px;
    /*position: relative;*/
    //导出按钮
    .excelBtn{
      padding: 14px 20px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      align-items: center;
      position: fixed;
      top: 260px;
      right: 200px;
      width: 120px;
      box-sizing: border-box;
      cursor: pointer;
      z-index: 1000;
      span{
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-top: 8px;
        text-align: center;
      }
    }
  }
  //tabs
  .tabs{
    height: 54px;
    ul{
      background-color: #fff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      width: 1200px;
      li{
        font-size: 14px;
        line-height: 20px;
        color: #666666;
        padding: 16px 0 18px 0;
        cursor: pointer;
        box-sizing: border-box;
        margin-right: 40px;
        &:last-child{
          margin-right: 0;
        }
      }
      li.active,li:hover{
        color: #4c84ff;
        position: relative;
        &:after{
          position: absolute;
          content: '';
          width: 100%;
          height: 2px;
          background-color: #4c84ff;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
  .fixed_c{
    z-index: 999;
    width: 1200px;
  }
  //对比列表
  .db_box{
    padding: 24px 0;
    background-color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    .title{
      font-size: 16px;
      line-height: 22px;
      color: #4c84ff;
      font-weight: bold;
      padding: 0 24px;
    }
    ul{
      display: flex;
      margin-top: 16px;
      overflow: hidden;
      li{
        flex: 1;
        border-right: 1px solid #EEEEEE;
        position: relative;
        padding: 0 24px;
        .txt{
          font-size: 14px;
          line-height: 20px;
          color: #333333;
        }
        .link{
          color: #2B6AE1;
          word-break: break-all;
        }
      }
      li:last-child{
        border: none;
      }
    }
    .more{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      font-size: 14px;
      line-height: 20px;
      color: #2B6AE1;
      cursor: pointer;
      position: absolute;
      background-color: #ffffff;
      bottom: 0;
      i{
        margin-left: 8px;
      }
    }
    .more.up i{
      transform: rotate(180deg);
    }
  }
  .db_box_h320{
    max-height: 320px;
  }
  .db_box_name{
    ul  li{
      padding: 34px 24px 0 24px;
      &:last-child{
        border: none;
      }
      .close{
        position: absolute;
        right: 24px;top: 0;
      }
    }
  }
  .db_box_types{
    ul  li{
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          padding: 3px 8px;
          background: #EEEEEE;
          border-radius: 2px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
          margin-right: 8px;
          margin-bottom: 8px;
        }
        .col1{
          background: rgba(255, 108, 50, 0.1);
          color: #ff733c;
        }
        .col2{
          background: rgba(43, 106, 225, 0.1);
          color: #2B6AE1;
        }
        .col3{
          background: rgba(48, 196, 206, 0.1);
          color: #30C4CE;
        }
        .col4{
          background: rgba(254, 55, 55, 0.1);
          color: #FE3737;
        }
        .col5{
          background: rgba(0, 186, 86, 0.1);
          color: #00BA56;
        }
        .col6{
          background: rgba(74, 76, 91, 0.1);
          color: #4A4C5B
        }
      }
    }
  }

}
</style>
